import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../../app/AllowedMicroservices";
import { RootState } from "../../../app/store";
import apiActionCreator, {
  HttpMethods,
} from "../../../services/apiActionCreator";
import { FetchStatus } from "../../common/enums";
import { DataState, IReportValue, sortReportValue } from "../common";

const initialState: DataState = {
  data: [],
  status: FetchStatus.Idle,
};

export const dataSlice = createSlice({
  name: "userEnabledVsDisabledByGender",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<IReportValue[]>) => {
      state.data = action.payload;
      state.data.sort(sortReportValue);
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.data = [];
      state.status = FetchStatus.Error;
    },
  },
});

export const { fetching, fetched, error } = dataSlice.actions;

export const fetchUsersEnabledVsDisabledByGender = (companyId: string) => (
  dispatch: Dispatch<object>
) => {
  let endpoint = `/user/reports/enabledVsDisabledbyGender/${companyId}`;
  return dispatch(
    apiActionCreator({
      endpoint,
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.GET,
      microservice: Microservices.COMPANY_SERVICE,
      authenticated: true,
    })
  );
};

export const selectUserEnabledVsDisabledByGenderData = (state: RootState) =>
  state.reports.user.userEnabledVsDisabledByGender.data;
export const selectUserEnabledVsDisabledByGenderIsFetching = (
  state: RootState
) =>
  state.reports.user.userEnabledVsDisabledByGender.status ===
  FetchStatus.Fetching;

export default dataSlice.reducer;
